export default __webpack_public_path__ + "static/media/success.1f2698c7.svg";